import base64ToBlob from './base64ToBlob';
import getInvoiceProps from './getInvoiceProps';
import getHtmlInvoice from './getHtmlInvoice';

const PDFHelpers = {
  base64ToBlob,
  getInvoiceProps,
  getHtmlInvoice,
};

export default PDFHelpers;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/index.js